.wrapper {
  display: inline-flex;
}

// The text variant inherits the medium tier's 50px box; Figma Button Links M is just the
// 19px text row. Nested (0,2,0) to beat the atom's `.sizeMedium` (0,1,0).
.wrapper .link {
  height: auto;
  min-width: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
}
